import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'
import { HostFamilyStudentRatingsResponse } from './types'

export function getHostFamilyStudentRatings(id: number) {
  return restApiClient
    .url(constructApiUrl(API.hostFamilies.getStudentAppreciations.url, { id }))
    .get<HostFamilyStudentRatingsResponse>()
}
